import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title,
  description,
  image,
  url,
  type = 'website',
  locale = 'en_US'
}) => {
  // Default values
  const defaults = {
    title: 'Samanext | Venture Studio & Cognitive Software',
    description: 'Architecting the future of global trade and finance. We build high-impact AI solutions like Eqtos.',
    image: 'https://customer-assets.emergentagent.com/job_4a49ee36-674e-4876-bdde-a21aaf32773b/artifacts/4ka36pr5_Logo%20Samanext%20Transparente.png',
    url: 'https://samanext.com',
    siteName: 'Samanext Technologies'
  };

  const seo = {
    title: title || defaults.title,
    description: description || defaults.description,
    image: image || defaults.image,
    url: url || defaults.url
  };

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <link rel="canonical" href={seo.url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={seo.url} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={seo.image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content={defaults.siteName} />
      <meta property="og:locale" content={locale} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={seo.url} />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />

      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="theme-color" content="#000000" />
      <meta name="msapplication-TileColor" content="#000000" />
    </Helmet>
  );
};

export default SEO;
